// extracted by mini-css-extract-plugin
export var active = "_d1-7";
export var container = "_d1-0";
export var evenWidth = "_d1-4";
export var large = "_d1-5";
export var outlet = "_d1-8";
export var slide = "_d1-2";
export var small = "_d1-6";
export var tab = "_d1-3";
export var tabs = "_d1-1";